import { ContainerComponent } from './container.component';
import { DiningOptionComponent } from './diningOption/diningOption.component';
import { RestaurantCardComponent } from './restaurantCard/restaurantCard.component';
import { RestaurantListComponent } from './restaurantList/restaurantList.component';

import { LocationPickerModule } from './locationPicker/location_picker.module';

export const ContainerModule = angular.module('oo.multilocation.picker.container', [
    LocationPickerModule
])
    .component('container', ContainerComponent)
    .component('diningOption', DiningOptionComponent)
    .component('restaurantCard', RestaurantCardComponent)
    .component('restaurantList', RestaurantListComponent)
    .name;
